import useDeleteZone from 'api/locationZone/useDeleteZone/useDeleteZone';
import useEditZone from 'api/locationZone/useEditZone/useEditZone';
import useInsertZone from 'api/locationZone/useInsertZone/useInsertZone';
import useLocationZone from 'api/locationZone/useLocationZone/useLocationZone';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import ZoneEditModal from 'components/shared/Modals/locationDetail/ZoneEditModal/ZoneEditModal';
import ZoneInsertModal from 'components/shared/Modals/locationDetail/ZoneInsertModal/ZoneInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useZoneTableColumns from 'hooks/locationDetail/useZoneTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const LocationDetail = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getZoneList, loading, zoneList, pageRef] = useLocationZone(guid);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenLocation, setEditChosenLocation] = useState({});
  const [editLoading, setEditLoading] = useState(false);
  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [insertLoading, setInsertLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [insertInputValue, setInsertInputValue] = useState('');

  const navigate = useNavigate();
  const [deleteRequest] = useDeleteZone();
  const [editRequest] = useEditZone();
  const [insertRequest] = useInsertZone();
  const { can } = usePermissions();

  const areaPermissions =
    permissions.general.categories.warehouseManagement.locationManagement
      .locations.areas;

  const canCreate = can(areaPermissions.create);
  const canDelete = can(areaPermissions.delete);
  const canEdit = can(areaPermissions.edit);
  const canGraph = can(areaPermissions.graph);
  const canViewBaskets = can(areaPermissions.baskets.view);

  const tableRef = useRef(null);

  useEffect(() => {
    getZoneList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getZoneList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/locations-graph/${row.id}`),
    [],
  );
  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );
  const editItem = useCallback(
    row => () => {
      setInputValue(row.title);
      setEditChosenLocation(row);
      setIsEditModalOpen(true);
    },
    [],
  );
  const basketsItem = useCallback(
    row => () => navigate(`/baskets/${row.id}`),
    [],
  );

  const [columnsData] = useZoneTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    basketsItem,
    tableRef,
    {
      canGraph,
      canEdit,
      canViewBaskets,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getZoneList, setIsDeleteModalOpen, setDeleteLoading);
  };

  const editHandle = id => {
    if (inputValue) {
      setEditLoading(true);
      editRequest(
        id,
        getZoneList,
        setIsEditModalOpen,
        setEditLoading,
        inputValue,
      );
    }
  };

  const insertHandle = () => {
    if (insertInputValue) {
      setInsertLoading(true);
      insertRequest(
        guid,
        getZoneList,
        setIsInsertModalOpen,
        setInsertLoading,
        insertInputValue,
        setInsertInputValue,
      );
    }
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getZoneList({ page: pageNumber, count: pageSize, term: lastSearch });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getZoneList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(zoneList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={zoneList[page]}
          rows={zoneList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'اضافه کردن منطقه جدید' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <ZoneEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          title={editChosenLocation.title}
          locationId={editChosenLocation.id}
          editLoading={editLoading}
          onEdit={editHandle}
          editInputValue={inputValue}
          inputOnchange={e => setInputValue(e.target.value)}
        />
      ) : null}

      {canCreate ? (
        <ZoneInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          insertLoading={insertLoading}
          onInsert={insertHandle}
          insertInputValue={insertInputValue}
          insertInputOnchange={e => setInsertInputValue(e.target.value)}
        />
      ) : null}
    </>
  );
};

export default LocationDetail;
